import { NgOptimizedImage } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';
import { ContentCardComponent } from '../form-block/content-card/content-card.component';
import { SpotlightBlockConfiguration } from './models/spotlight-block.types';

@Component({
    selector: 'nw-spotlight-block',
    imports: [NgOptimizedImage, ContentCardComponent, SanitizeHtmlPipe],
    templateUrl: './spotlight-block.component.html',
    styleUrl: './spotlight-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightBlockComponent implements OnChanges {
    @Input() config!: SpotlightBlockConfiguration.Config | string;

    public configuration!: SpotlightBlockConfiguration.Config;

    public ngOnChanges({ config }: SimpleChanges): void {
        if (config?.currentValue) {
            this.configuration =
                typeof this.config === 'string'
                    ? JSON.parse(this.config)
                    : { ...this.config };
        }
    }
}
